import { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { Send } from 'lucide-react';
import { toast } from 'sonner';

const Appreciation = ({ user }) => {
  const [stagiaires, setStagiaires] = useState([]);
  const [selectedStagiaire, setSelectedStagiaire] = useState('');
  const [texte, setTexte] = useState('');

  useEffect(() => {
    loadStagiaires();
  }, []);

  const loadStagiaires = async () => {
    try {
      const response = await axios.get('/stagiaires');
      setStagiaires(response.data);
      if (response.data.length > 0) {
        setSelectedStagiaire(response.data[0].user_id);
      }
    } catch (error) {
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedStagiaire || !texte.trim()) {
      toast.error('Veuillez remplir tous les champs');
      return;
    }

    try {
      await axios.post(`/entreprises/${user.user_id}/appreciation`, {
        stagiaire_id: selectedStagiaire,
        texte
      });

      toast.success('Appréciation envoyée au centre de formation');
      setTexte('');
    } catch (error) {
      toast.error('Erreur lors de l\'envoi');
    }
  };

  return (
    <div className="space-y-6" data-testid="appreciation-page">
      <div>
        <h1 className="text-4xl font-display font-bold text-[#0F172A] mb-2">Appréciation Stagiaire</h1>
        <p className="text-slate-600">Envoyez une appréciation libre au centre de formation</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="bg-white border border-slate-200 rounded-lg p-6 shadow-sm">
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="stagiaire">Stagiaire</Label>
              <select
                id="stagiaire"
                value={selectedStagiaire}
                onChange={(e) => setSelectedStagiaire(e.target.value)}
                className="w-full h-10 px-3 py-2 text-sm border border-slate-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#8DC63F]"
                data-testid="select-stagiaire"
              >
                {stagiaires.map((s) => (
                  <option key={s.user_id} value={s.user_id}>
                    {s.user_info?.prenom} {s.user_info?.nom}
                  </option>
                ))}
              </select>
            </div>

            <div className="space-y-2">
              <Label htmlFor="texte">Appréciation Libre</Label>
              <textarea
                id="texte"
                value={texte}
                onChange={(e) => setTexte(e.target.value)}
                rows="8"
                className="w-full px-3 py-2 text-sm border border-slate-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#8DC63F]"
                placeholder="Écrivez votre appréciation sur le stagiaire (comportement, compétences, intégration, etc.)..."
                data-testid="textarea-appreciation"
              />
            </div>

            <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <p className="text-sm text-blue-700">
                ℹ️ Cette appréciation sera envoyée directement au <strong>centre de formation</strong>.
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-end">
          <Button
            type="submit"
            className="bg-[#8DC63F] hover:bg-[#7db336] text-white px-8"
            data-testid="submit-appreciation-button"
          >
            <Send className="h-4 w-4 mr-2" />
            Envoyer au Centre
          </Button>
        </div>
      </form>
    </div>
  );
};

export default Appreciation;